module.exports = __webpack_public_path__ + "1e24bf864f806fa881cf407f55181600.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg4.jpg
 ** module id = 509
 ** module chunks = 1
 **/